import { BaseEntity } from '../../../../models';
import { Representante } from '../../../pessoa/representante';

export class CampanhaRepresentante implements BaseEntity {
    readonly id: number;
    idCampanha: number;
    idRepresentante: number;
    representante: Representante;
}
